import type { LiveAmbiguityGroup, Slot } from "@cs2/contracts";
import { CloseButton, Dialog } from "../../../shared/ui/index.js";

/**
 * Nur für den Captain: wenn mehrere online verbundene Mitglieder auf
 * dieselbe(n) Position(en) matchen würden, hier schnell klick-zuweisen. Kein
 * Bestätigen-Button — ein Klick auf einen Kandidaten-Chip löst sofort auf
 * (Tempo für den Wechsel zwischen Runden). Schließen vertagt nur lokal, ohne
 * den Server-Zustand zu ändern — die nächste echte Zustandsänderung (z. B.
 * ein neu verbundenes Mitglied) kann dieselbe Mehrdeutigkeit erneut melden.
 */
export function AmbiguityPanel({
  groups,
  onResolve,
  onDismiss,
}: {
  groups: LiveAmbiguityGroup[];
  onResolve: (assignments: Partial<Record<Slot, string | null>>) => void;
  onDismiss: () => void;
}) {
  return (
    <Dialog
      open
      onClose={onDismiss}
      title="POSITIONEN ZUORDNEN"
      contentClassName="qv-dialog-card ambiguity-panel"
    >
      <CloseButton className="ui-dialog-close-corner" onClick={onDismiss} />
      <p>LIVE-MATCHING</p>
      <h2>POSITIONEN ZUORDNEN</h2>
      <p className="ambiguity-hint">
        Mehrere online verbundene Mitglieder passen auf dieselbe Position —
        einmal antippen weist sofort zu.
      </p>
      {groups.map((group) => (
        <div className="ambiguity-group" key={group.slots.join(",")}>
          {group.slots.map((slot) => (
            <div className="ambiguity-slot-row" key={slot}>
              <b>{slot}</b>
              <div className="ambiguity-candidates">
                {group.candidates
                  .filter((candidate) => candidate.slot === slot)
                  .map((candidate) => (
                    <button
                      key={candidate.memberId}
                      type="button"
                      className={
                        group.prefill[slot] === candidate.memberId
                          ? "active"
                          : ""
                      }
                      onClick={() => onResolve({ [slot]: candidate.memberId })}
                    >
                      {candidate.email}
                    </button>
                  ))}
              </div>
            </div>
          ))}
        </div>
      ))}
    </Dialog>
  );
}
